import { InjectionToken } from "@angular/core";
export var WEBGL2 = new InjectionToken("webgl2");
export var GLTF = new InjectionToken("gltf data");
export var GLSL_VERSION = new InjectionToken("glsl version");
export var SHADER_DEFINITIONS = new InjectionToken("#define to add to beginning of shader source");
//# sourceMappingURL=webgl2-token.js.map